window.GitHubCalendar = require('../themes/developer/assets/plugins/github-calendar/dist/github-calendar.min.js');
